import i18n from "@/i18n";
import NotificationStatus from "../../constants/NotificationStatus";
import ConfigurationView from "../../constants/ConfigurationView";
import PromisseStatus from "@/constants/errors-http/PromisseStatus";

const getters = {
	/**
	 * Retorna true se a view do configurador for criação/atualização.
	 */
	isCreateOrUpdateStepper(state)
	{
		return state.configuratorView === ConfigurationView.CREATE_OR_UPDATE;
	},

	/**
	 * Obtém o nome dos ativos selecionados.
	 */
	selectedAssetsNames(state)
	{
		return state.selectedAssets.map((item) => item.name);
	},

	/**
	 * Obtém a mensagem de notificação com base no tipo de notificação habilitado.
	 */
	notificationMessage(state)
	{
		if (state.limitAndNotificationsSettings.enabledNotificationsOption === NotificationStatus.ENABLE_GENERAL)
		{
			return i18n.t("Labels.FrequencyTrendLimitConfiguration.EnableGeneralNotifications");
		}
		else if (
			state.limitAndNotificationsSettings.enabledNotificationsOption === NotificationStatus.ENABLE_ALERT_LIMIT
		)
		{
			return i18n.t("Labels.FrequencyTrendLimitConfiguration.EnableAlertAndAttentionNotifications");
		}
		else
		{
			return i18n.t("Labels.Disabled");
		}
	},

	/**
	 * Obtém os IDs de configuração de tendência de frequência para sinais selecionados.
	 */
	selectedFrequencyTrendSignalIds(state)
	{
		return (state.selectedSignal && Array.isArray(state.selectedSignal.info) ? state.selectedSignal.info : [])
			.map(item => item.frequencyTrendSettingId);
	},

	/**
	 * Retorna o nome das turbinas apenas quando a chamada para criar/atualizar ocorra um problema parcial.
	 * @returns {string} Mensagem de feedback correspondente ao resultado das operações.
	 */
	turbinesFromPartialError(state)
	{
		const failedResults = state.updateResults.filter((result) => result.status === PromisseStatus.REJECTED);
		const successfulResults = state.updateResults.filter((result) => result.status === PromisseStatus.FULFILLED);
		if (failedResults.length > 0 && successfulResults.length > 0)
		{
			return failedResults.map((result) => result.turbine).join(", ");
		}
	},

	/**
	 * Obtém o nome do sinal selecionado.
	 * @returns Nome do sinal.
	 */
	selectedSignalName(state)
	{
		return state.selectedSignal.name;
	},

	/**
	 * Obtém os valores e rótulos dos radio buttons de visualização dos steppers.
	 */
	configuratorViewRadioButtons()
	{
		return [
			{
				value: ConfigurationView.CREATE_OR_UPDATE,
				label: i18n.t("Buttons.CreateOrUpdate")
			},
			{
				value: ConfigurationView.DELETE,
				label: i18n.t("Buttons.Delete")
			},
		];
	},
};

export default { getters };
